import React from 'react';
import SEO from '../components/SEO';
import structuredData from '../data/structuredData.json';
// import solutionbg from '../images/solution-bg.svg';
import solutionbg from '../images/solution-bg-image.png';
import { IconChevronRight } from '@tabler/icons-react';
import Header from '../components/Header';
import SolutionTab from '../components/SolutionTab';
import stay from '../images/bg-image-card.svg';
import discord from '../images/discord-card-bg.svg';
import gitcard from '../images/git-card-bg.svg';
import Faq from '../components/Faq'
import edmcard from '../images/edm-card-bg-image.png';
import surface from '../images/surface-grinding.png';
import { IconHeadset } from '@tabler/icons-react';
import { IconHeartHandshake } from '@tabler/icons-react';
import { IconCheck } from '@tabler/icons-react';
import { IconBuildingFactory2 } from '@tabler/icons-react';
import { IconTool } from '@tabler/icons-react';
import { IconPuzzle2 } from '@tabler/icons-react';
import { IconChartCohort } from '@tabler/icons-react';
import { IconSettingsStar } from '@tabler/icons-react';
import { IconBrandDatabricks } from '@tabler/icons-react';
import { IconFilters } from '@tabler/icons-react';
import cncmachining from '../images/cnc-machining.png';
import highaccuracy from '../images/high-accuracy-part.png';


const solution = () => {
    return (
        <>
            <SEO
                title="Precision Engineering Solutions Malaysia | GXL"
                description="Discover precision engineering solutions in Malaysia, including CNC machining, EDM, automation, jigs & fixtures, and prototyping services."
                url="/solutions"
                type="website"
                noSuffix
                structuredData={structuredData.solutions}
            />
            <section
                style={{
                    backgroundImage: `url(${solutionbg})`,
                    backgroundPosition: '50% 0',
                }}
                className="bg-no-repeat bg-cover max-w-none relative">
                <Header />
                <div className='lg:py-24 py-10'>
                    <div className="container lg:px-10 px-6 max-w-[1600px] mx-auto">
                        <div className="grid grid-cols-1">
                            <div className='lg:space-y-10 space-y-6'>
                                <div className='space-y-2'>
                                    <p className='text-[#fff]/90 text-sm lg:text-base font-medium text-center max-w-[740px] mx-auto'>Modernise precision engineering development with us</p>
                                    <h1 className='lg:text-5xl md:text-4xl text-3xl font-semibold bg-[radial-gradient(89.47%_51.04%_at_44.27%_50%,_#E2E3E9_0%,_#D4D6DE_52.73%,_#3D3F4C_100%)] bg-clip-text text-transparent text-center max-w-[740px] mx-auto leading-normal lg:leading-[65px]'>Integrated Precision Engineering Solutions </h1>
                                    <p className='text-[rgb(171,174,187)] lg:text-lg text-base font-medium text-center max-w-[740px] mx-auto '>At GXL, we specialize in delivering custom, high-precision solutions tailored to your industry's toughest challenges—from prototyping to full-scale production. </p>
                                </div>
                                <div className='mt-9 flex items-center gap-x-6 lg:gap-x-5 md:mt-7 md:gap-x-8 sm:mt-7 sm:flex-row justify-center flex-col sm:gap-y-0 gap-y-4'>
                                    <a
                                        href="/contact"
                                        className="transition-colors duration-300 group inline-flex items-center outline-none justify-center tracking-tight leading-none focus:outline-white focus:outline-1 focus:outline-offset-4 h-10 text-[15px] px-6 rounded-full md:h-10 shadow-[0px_2px_2px_0px_rgba(0,0,0,0.74)] font-semibold relative">
                                        <span className="absolute -inset-px bottom-[-1.5px] rounded-full bg-[linear-gradient(180deg,#fcc171_0%,#C17C56_50%,#362821_100%)]"></span>
                                        <span className="absolute -top-[5px] bottom-0.5 left-1/2 w-[91%] -translate-x-1/2 bg-btn-glowing mix-blend-screen blur-[1px] transition-transform duration-300 ease-in-out group-hover:translate-y-[-2px]"></span>
                                        <span className="absolute inset-0 rounded-full bg-black"></span>
                                        <span className="absolute inset-0 rounded-full bg-btn-glowing-inset opacity-100 transition-opacity duration-300 ease-in-out group-hover:opacity-0"></span>
                                        <span className="absolute inset-0 rounded-full bg-btn-glowing-inset-hover opacity-0 transition-opacity duration-300 ease-in-out group-hover:opacity-100"></span>
                                        <span className="relative z-20 bg-[linear-gradient(180deg,#FFF_33.33%,#E4D0B1_116.67%)] bg-clip-text text-transparent">
                                            Discover Our Expertise
                                        </span>
                                    </a>
                                    <a href="/contact" className="group text-base font-medium text-white flex gap-1 items-center hover:text-[#fcc171] transition-colors duration-200">
                                        Let's Build Together
                                        <IconChevronRight
                                            size={20}
                                            stroke={2}
                                            className="chevron-icon group-hover:translate-x-1 transition-transform duration-300"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='bg-[#E4E5E7] lg:py-16 py-10'>
                <div className='container-md  lg:px-10 px-6 max-w-[1600px] mx-auto'>
                    <div className='space-y-2'>
                        <h2 className='text-gray-800 lg:text-5xl text-center text-3xl  lg:max-w-[644px] font-medium  2xs:max-w-72 mx-auto'>Tailored Precision for Every Industry </h2>
                        <p className='text-gray-800 lg:max-w-[588px] mx-auto text-center lg:text-lg text-base font-medium'>We deliver high-tolerance, high-performance components and systems designed for industries where precision is non-negotiable.</p>
                    </div>
                    <div className="grid lg:grid-cols-2 md:grid-cols-2 gap-4 lg:mt-10  mt-6">
                        <div
                            style={{ backgroundImage: `url(${cncmachining})` }}
                            className='px-5 py-6 rounded-2xl h-[370px] bg-cover flex items-end justify-between group transition-all duration-300 cursor-pointer  '>
                            <div className='space-y-2'>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>CNC Machining (Turning & Milling)<span
                                    className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out"
                                >
                                    <IconChevronRight className="" size={20} stroke={2} />
                                </span></h3>
                                <p className='text-white font-normal text-sm'>Automated cutting of parts with high precision using computer-controlled machines.</p>
                            </div>
                        </div>
                        <div
                            style={{ backgroundImage: `url(${edmcard})` }}
                            className='px-5 py-6 rounded-2xl h-[370px] bg-cover flex items-end justify-between group transition-all duration-300 cursor-pointer '>
                            <div className='space-y-2'>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>EDM (Wire Cut, Sinker EDM)<span
                                    className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out" >
                                    <IconChevronRight className="" size={20} stroke={2} />
                                </span></h3>
                                <p className='text-white font-normal text-sm'>Electrical discharge machining for shaping hard metals with extreme precision.</p>
                            </div>
                        </div>
                        <div
                            style={{ backgroundImage: `url(${surface})` }}
                            className='px-5 py-6 rounded-2xl h-[370px]  bg-cover flex items-end justify-between group transition-all duration-300 cursor-pointer '>
                            <div className='space-y-2'>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>Surface Grinding<span
                                    className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                                    <IconChevronRight className="" size={20} stroke={2} />
                                </span></h3>
                                <p className='text-white font-normal text-sm'>Finishing process to achieve smooth, flat surfaces with tight tolerances.</p>
                            </div>
                        </div>
                        <div
                            style={{ backgroundImage: `url(${highaccuracy})` }}
                            className='px-5 py-6 rounded-2xl h-[370px]  bg-cover flex items-end justify-between group transition-all duration-300 cursor-pointer '>
                            <div className='space-y-2'>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>Surface finish & Hardening Solution<span
                                    className="opacity-0 group-hover:opacity-100 transform group-hover:translate-x-1 motion-safe:transition-all duration-300 ease-in-out">
                                    <IconChevronRight className="" size={20} stroke={2} />
                                </span></h3>
                                <p className='text-white font-normal text-sm'>Provides surface finish/color/coating & hardening of metal parts. </p>
                            </div>
                        </div>
                    </div>
                    <div className='grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 lg:gap-12 gap-6 lg:mt-10 mt-6'>
                        <div className='space-y-2'>
                            <div className='flex items-center gap-3'>
                                <IconTool className='text-[#e37e5d]' size={26} stroke={2} />
                                <h3 className=" text-gray-900 lg:text-xl text-lg font-semibold flex gap-4">
                                    High-Precision Tools & Dies
                                </h3>
                            </div>
                            <p className=" text-gray-600 lg:text-base text-sm font-normal">Accurate tools used to shape or cut materials. </p>
                        </div>
                        <div className='space-y-2'>
                            <div className='flex items-center gap-3'>
                                <IconPuzzle2 className='text-[#e37e5d]' size={26} stroke={2} />
                                <h3 className=" text-gray-900 lg:text-xl text-lg font-semibold flex gap-4">
                                    Jigs & Fixtures
                                </h3>
                            </div>
                            <p className=" text-gray-600 lg:text-base text-sm font-normal">Devices that guide and hold parts for machining or assembly.</p>
                        </div>
                        <div className='space-y-2'>
                            <div className='flex items-center gap-3'>
                                <IconChartCohort className='text-[#e37e5d]' size={26} stroke={2} />
                                <h3 className=" text-gray-900 lg:text-xl text-lg font-semibold flex gap-4">
                                    Mold Parts
                                </h3>
                            </div>
                            <p className=" text-gray-600 lg:text-base text-sm font-normal">Components used in molds to shape materials like plastic or metal. </p>
                        </div>
                        <div className='space-y-2'>
                            <div className='flex items-center gap-3'>
                                <IconSettingsStar className='text-[#e37e5d]' size={26} stroke={2} />
                                <h3 className=" text-gray-900 lg:text-xl text-lg font-semibold flex gap-4">
                                    Carbide Tooling
                                </h3>
                            </div>
                            <p className=" text-gray-600 lg:text-base text-sm font-normal">Cutting tools made from hard carbide for tough materials.</p>
                        </div>
                        <div className='space-y-2'>
                            <div className='flex items-center gap-3'>
                                <IconBrandDatabricks className='text-[#e37e5d]' size={26} stroke={2} />
                                <h3 className=" text-gray-900 lg:text-xl text-lg font-semibold flex gap-4">
                                    Precision Machined Components
                                </h3>
                            </div>
                            <p className=" text-gray-600 lg:text-base text-sm font-normal">Exactly machined parts for tight tolerances. </p>
                        </div>
                        <div className='space-y-2'>
                            <div className='flex items-center gap-3'>
                                <IconFilters className='text-[#e37e5d]' size={26} stroke={2} />
                                <h3 className=" text-gray-900 lg:text-xl text-lg font-semibold flex gap-4">
                                    Mechanical CAD Design
                                </h3>
                            </div>
                            <p className=" text-gray-600 lg:text-base text-sm font-normal">3D design of mechanical parts using computer software. </p>
                        </div>
                    </div>
                </div>
            </section>
            <SolutionTab />
            <section className='bg-[#E5E5E6] lg:py-16 py-10'>
                <div className='container-md lg:px-10 px-6 max-w-[1600px] mx-auto'>
                    <div className='space-y-3'>
                        <div className='space-y-2'>
                            <h2 className='text-gray-800 lg:text-5xl text-3xl text-center font-medium '>Engagement models</h2>
                            <p className='text-gray-800 text-center lg:text-lg text-base font-medium'>Choose the model that best suits your team and project.</p>
                        </div>
                    </div>
                    <div className='grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-4 lg:mt-10 mt-6 models-card '>
                        <div
                            className='relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-5 rounded-2xl h-[310px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer models-card-item'>
                            <img
                                alt="Contribute to open source"
                                className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                                loading="lazy"
                                decoding="async"
                                data-nimg="1"
                                src={gitcard}
                                style={{ color: 'transparent' }}
                            />
                            <div className='relative z-10 flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-gradient-to-b from-[#3B3B47] to-[#040406] md:h-12 md:w-12'>
                                <IconBuildingFactory2 className='text-[#fff]/70' size={32} stroke={1.5} />
                            </div>
                            <div className='space-y-2'>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>Project-Based Manufacturing </h3>
                                <ul className='m-0 space-y-1'>
                                    <li className='text-base text-[rgb(171,174,187)] flex items-center gap-1'>
                                        <IconCheck size={20} stroke={1.5} />
                                        Fast turnaround for defined specs
                                    </li>
                                    <li className='text-base text-[rgb(171,174,187)] flex items-center gap-1'>
                                        <IconCheck size={20} stroke={1.5} />
                                        Ideal for prototypes and small batches
                                    </li>
                                    <li className='text-base text-[rgb(171,174,187)] flex items-center gap-1'>
                                        <IconCheck size={20} stroke={1.5} />
                                        Minimal client oversight required
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            className='relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-6 rounded-2xl h-[310px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer models-card-item'
                        >
                            <img
                                alt="Contribute to open source"
                                className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                                loading="lazy"
                                decoding="async"
                                data-nimg="1"
                                src={stay}
                                style={{ color: 'transparent' }}
                            />
                            <div className='relative z-10 flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-gradient-to-b from-[#3B3B47] to-[#040406] md:h-12 md:w-12'>
                                <IconHeartHandshake className='text-[#fff]/70' size={32} stroke={1.5} />
                            </div>
                            <div className='space-y-2'>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>Co-Development Partnership  </h3>
                                <ul className='m-0 space-y-1'>
                                    <li className='text-base text-[rgb(171,174,187)] flex items-center gap-1'>
                                        <IconCheck size={20} stroke={1.5} />
                                        Collaborate on design and engineering
                                    </li>
                                    <li className='text-base text-[rgb(171,174,187)] flex items-center gap-1'>
                                        <IconCheck size={20} stroke={1.5} />
                                        Build in-house knowledge with expert support
                                    </li>
                                    <li className='text-base text-[rgb(171,174,187)] flex items-center gap-1'>
                                        <IconCheck size={20} stroke={1.5} />
                                        Shared ownership of process and outcomes
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            className='relative overflow-hidden px-5 bg-[rgb(18,19,23)] py-5 rounded-2xl h-[310px] bg-cover flex flex-col justify-between group transition-all duration-300 cursor-pointer'>
                            <img
                                alt="Contribute to open source"
                                className="pointer-events-none absolute inset-0 w-full right-0 top-0"
                                loading="lazy"
                                decoding="async"
                                data-nimg="1"
                                src={discord}
                                style={{ color: 'transparent' }}
                            />
                            <div className='relative z-10 flex h-11 w-11 items-center justify-center overflow-hidden rounded-full bg-gradient-to-b from-[#3B3B47] to-[#040406] md:h-12 md:w-12'>
                                <IconHeadset className='text-[#fff]/70' size={32} stroke={1.5} />
                            </div>
                            <div className='space-y-2'>
                                <h3 className='text-white text-lg font-medium flex items-center leading-[inherit]'>Dedicated Production Support </h3>
                                <ul className='m-0 space-y-1'>
                                    <li className='text-base text-[rgb(171,174,187)] flex items-center gap-1'>
                                        <IconCheck size={20} stroke={1.5} />
                                        Long-term manufacturing collaboration
                                    </li>
                                    <li className='text-base text-[rgb(171,174,187)] flex items-center gap-1'>
                                        <IconCheck size={20} stroke={1.5} />
                                        Consistent quality and supply chain integration
                                    </li>
                                    <li className='text-base text-[rgb(171,174,187)] flex items-center gap-1'>
                                        <IconCheck size={20} stroke={1.5} />
                                        On-site and remote technical support
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Faq />
        </>
    );
};

export default solution;
